var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-social-list"},_vm._l((_vm.items),function({ id, title, url, icon }){return _c('a',{key:id,attrs:{"href":url,"aria-label":title,"target":"_blank"}},[_c('img',{attrs:{"src":icon.data.attributes.url,"alt":title}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }